import { EventSubscriptionsGridView } from '~/components/system/event-subscriptions';
import { PageContainer } from '~/components/page-container';

export function EventSubscriptions() {
	return (
		<PageContainer>
			<EventSubscriptionsGridView />
		</PageContainer>
	);
}
